import { countries } from 'country-data-list';

const REGION_CODES = new Set([
  'GLOBAL', 'REST_OF_WORLD', 'ASC', 'EUROPE', 'AND', 'ASIA',
  'NORTH_AMERICA', 'SOUTH_AMERICA', 'AFRICA', 'ANTARTICA',
  'OCEANIA', 'CENTRAL_AMERICA', 'CARIBBEAN',
]);

const alpha3ToAlpha2Map: Record<string, string> = {};
const alpha3ToNameMap: Record<string, string> = {};

countries.all.forEach((c: { alpha3?: string; alpha2?: string; name?: string; status?: string }) => {
  if (c.alpha3 && c.alpha2 && c.status !== 'deleted') {
    alpha3ToAlpha2Map[c.alpha3] = c.alpha2.toLowerCase();
    alpha3ToNameMap[c.alpha3] = c.name || c.alpha3;
  }
});

export function isRegionCode(code: string): boolean {
  return !code || REGION_CODES.has(code);
}

export function isGlobalMethod(countryCodes: string[]): boolean {
  return countryCodes.some(c => c === 'GLOBAL' || c === 'REST_OF_WORLD');
}

export function getRealCountries(countryCodes: string[]): string[] {
  return countryCodes.filter(c => c && !isRegionCode(c) && alpha3ToAlpha2Map[c]);
}

export function getAlpha2(alpha3: string): string {
  return alpha3ToAlpha2Map[alpha3] || alpha3.slice(0, 2).toLowerCase();
}

export function getCountryName(alpha3: string): string {
  try {
    const displayNames = new Intl.DisplayNames(['pt-BR'], { type: 'region' });
    const alpha2 = alpha3ToAlpha2Map[alpha3]?.toUpperCase();
    if (alpha2) {
      const name = displayNames.of(alpha2);
      if (name) return name;
    }
  } catch { /* fallback */ }
  return alpha3ToNameMap[alpha3] || alpha3;
}
